import React, { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import Reactportal from "../Reactportal/Reactportal";
import { GetOnlyYear, OnlyToShowDate } from "../../../CommonFunction/IsoDateTime";
import "./FinancialYearSelection.scss";
import { useDispatch, useSelector } from "react-redux";
import { setFinancialYear } from "../../../Store/FinancialDates/FinancialDates.reducer";
import { useModalContext } from "../Reactportal/ModalContext";

const FINANCIAL_YEARS_QUERY = gql`
  query FinancialYearsWithCompanyCode {
    Financial_Years_With_CompanyCode {
      _id
      Unique_Id
      From_Date
      To_Date
      createdAt
      updatedAt
    }
  }
`;

const SelectFinancialYear = ({ setToggle, show, onYearSelected }) => {
  const [getData, { data }] = useLazyQuery(FINANCIAL_YEARS_QUERY, {
    fetchPolicy: "network-only",
  });
  const Form_Key = "FinancialYearSelection";
  const { pushModal, popModal } = useModalContext();
  const dispatch = useDispatch();
  const selectedYearId = JSON.parse(sessionStorage.getItem("SelectedFinancialYear"))?.id;

  const closeForm = () => {
    setToggle(false);
  };

  useEffect(() => {
    getData();
  }, []);

  function findCurrentFinancialYear(financialYears) {
    const currentDate = new Date();
    return financialYears.find((year) => {
      const fromDate = new Date(year.From_Date);
      const toDate = new Date(year.To_Date);
      return fromDate <= currentDate && currentDate <= toDate;
    });
  }

  useEffect(() => {

    if (!selectedYearId && data?.Financial_Years_With_CompanyCode?.length > 0) {
      const latestYear = data.Financial_Years_With_CompanyCode.reduce((a, b) =>
        new Date(a.To_Date) > new Date(b.To_Date) ? a : b
      );
      let years = data?.Financial_Years_With_CompanyCode
      let defaultYear = findCurrentFinancialYear(years) || years?.length && years[years.length - 1]
      handleYearSelection(defaultYear, false); // Pass `false` to avoid auto-closing the modal
    }
  }, [data]);

  const handleYearSelection = (financialYear, shouldCloseForm = true) => {
    console.log(financialYear);
    if (financialYear) {
      const yearRange = `${OnlyToShowDate(financialYear?.From_Date)} - ${OnlyToShowDate(financialYear?.To_Date)}`;
      onYearSelected(yearRange);
      const financialYearObj = {
        id: financialYear._id,
        uniqueId: financialYear.Unique_Id,
        fromDate: financialYear.From_Date,
        toDate: financialYear.To_Date,
        yearRange: yearRange,
      };
      sessionStorage.setItem("SelectedFinancialYear", JSON.stringify(financialYearObj));
      dispatch(setFinancialYear(yearRange));
      dispatch({ type: "Refetch", payload: true });
      if (shouldCloseForm) closeForm();
    }
  };

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  // console.log(data)
  return (
    <>
      {show && (
        <Reactportal open={show} onClose={closeForm} TypeOfPortal={"Select Financial Year"} Form_Key={Form_Key}>
          <div className="FinancialYearSelection">
            {data?.Financial_Years_With_CompanyCode.map((year) => (
              <div
                key={year._id}
                onClick={() => handleYearSelection(year)}
                className={`FinancialYearItem ${year._id === selectedYearId ? "FinancialYearItemSelected" : ""}`}
              >
                <p>{`${GetOnlyYear(year.From_Date)} - ${GetOnlyYear(year.To_Date)}`}</p>
              </div>
            ))}
          </div>
        </Reactportal>
      )}
    </>
  );
};

export default SelectFinancialYear;
